import { ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { IBomModel, IShoppingCart } from '../../../prisma-xs/models/bom.model';
import { TooltipDirective } from '../../directives/tooltip.directive';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-ui-shopping-cart-button',
    templateUrl: './shopping-cart-button.component.html',
    styleUrls: ['./shopping-cart-button.component.scss'],
    standalone: false
})
export class ShoppingCartButtonComponent {
  @ViewChild('formElement') private formElementEl: ElementRef<HTMLFormElement>;
  @ViewChild('version') private versionEl: ElementRef<HTMLInputElement>;
  @ViewChild('result') private resultEl: ElementRef<HTMLInputElement>;
  @ViewChild('loading') private loadingEl: ElementRef<HTMLElement>;
  @ViewChild(TooltipDirective) private tooltipEl: TooltipDirective;

  @Input() bomModels: IBomModel[];
  @Input() wholesalerUnableToTransferDevicesIncluded: boolean;
  @Input() preWiringDevicesIncluded: boolean;
  @Input() selectedItemsCount: number;
  @Input() numberOfPositions: number;
  @Input() bomModelsAccessories: IBomModel[];
  @Input() selectedItems: number[];
  @Input() selectedItemsAccessories: number[];
  @Input() selectedItemsProjectComponents: number[];

  @Output() goToShoppingCart = new EventEmitter<IShoppingCart>();

  buttonClicked() {
    this.goToShoppingCart.emit({
      wholesalerUnableToTransferDevicesIncluded: this.wholesalerUnableToTransferDevicesIncluded,
      preWiringDevicesIncluded: this.preWiringDevicesIncluded,
      numberOfPositions: this.numberOfPositions
    });
  }

  toggleTooltip() {
    this.tooltipEl.show();
  }

  submitForm(hookUrl: string, result: string, version: string) {

    this.formElementEl?.nativeElement.setAttribute('action', hookUrl);
    this.versionEl?.nativeElement.setAttribute('value', version);
    this.resultEl?.nativeElement.setAttribute('value', result);

    setTimeout(() => {
      this.formElementEl?.nativeElement.submit();
      this.toggleLoading();
    }, 400);
  }

  toggleLoading() {
    ['icon18', 'se-icon-segment_retail', 'mb-1', 'iconSize', 'pl-1'].forEach(className => {
      this.loadingEl.nativeElement.classList.toggle(className);
    });
    ['spinner-border', 'spinner-border-sm', 'mr-2', 'ml-1', 'mt-1'].forEach(className => {
      this.loadingEl.nativeElement.classList.toggle(className);
    })
  }
}
